import { updateItems } from '@/mocks/darkwebData';

const tagColors: Record<string, string> = {
  '黑市动态': 'bg-accent-100 text-accent-800',
  '犯罪事件': 'bg-primary-100 text-primary-700',
  '安全政策': 'bg-secondary-100 text-secondary-800',
  '数据泄露': 'bg-primary-100 text-primary-700',
  '吃瓜爆料': 'bg-accent-100 text-accent-800',
  '安全技术': 'bg-secondary-100 text-secondary-800',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1440px] mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              暗网动态追踪
            </h2>
            <p className="text-foreground-600 text-sm mt-2">
              实时暗网快讯，第一时间掌握暗网世界动向
            </p>
          </div>
          <span className="hidden sm:flex items-center gap-1.5 text-xs text-accent-500 whitespace-nowrap">
            <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
            实时更新中
          </span>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-3 bottom-3 w-0.5 bg-background-300"></div>

          <div className="space-y-6">
            {updateItems.map((item) => (
              <article key={item.id} className="relative pl-12 group cursor-pointer">
                <div className="absolute left-[11px] top-3 w-[18px] h-[18px] rounded-full border-2 border-primary-500 bg-background-100 group-hover:bg-primary-500 transition-colors z-10"></div>
                <div className="bg-background-50 border border-background-200/70 rounded-lg p-4 md:p-5 group-hover:border-primary-300 transition-colors">
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <span className="text-xs text-foreground-500 whitespace-nowrap">
                      {item.date} {item.time}
                    </span>
                    <span
                      className={`inline-block text-xs px-2 py-0.5 rounded font-medium whitespace-nowrap ${
                        tagColors[item.tag] || 'bg-background-200 text-foreground-700'
                      }`}
                    >
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 mb-1.5">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {item.summary}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}